import { Globe } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createWebsitesFilterConfig(): FilterStringConfig {
  return {
    label: 'Websites',
    icon: <Globe className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: 'Search websites'
    }
  };
}
